import { getResource } from '../utilities/service-utils'

export const getDestinationAirports = () => {
  return getResource('airport/destination')
}

export const getOriginAirports = () => {
  return getResource('airport/origin')
}